import withDraft from '@/utils/draftHelper';
import { removeItemByCode } from '@/utils/resultsHelper';
import actions from '../../constants';
import { findCollectionDataset } from './state';

const closeCollectionDatasets = withDraft((draft, { category, code }) => {
  const item = findCollectionDataset(draft, { category, code });
  if (item) {
    draft.collectionDatasets[category].results = removeItemByCode(
      draft.collectionDatasets[category].results,
      item,
    );
  }
});

export default {
  [actions.CLOSE_COLLECTION]: closeCollectionDatasets,
};
